var map = {
	"./app-development.svg": 5177,
	"./problem-analysis.svg": 9108,
	"./product-integration.svg": 4288,
	"./s1.svg": 8624,
	"./s10.svg": 9184,
	"./s11.svg": 4721,
	"./s12.svg": 1586,
	"./s13.svg": 6227,
	"./s14.svg": 6044,
	"./s15.svg": 5517,
	"./s16.svg": 1342,
	"./s17.svg": 5071,
	"./s2.svg": 5715,
	"./s3.svg": 5138,
	"./s4.svg": 4429,
	"./s5.svg": 8972,
	"./s6.svg": 7999,
	"./s7.svg": 3710,
	"./s8.svg": 4265,
	"./s9.svg": 2731,
	"./solution-structure.svg": 6661
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7075;